import type {ReactNode} from 'react'
import {memo} from 'react'

type Props = {
  text: string
  regexp: RegExp
  renderResult: (result: ReactNode) => ReactNode
  renderMatched: (key: string, text: string, matchPosition: number) => ReactNode
  renderUnmatched: (key: string, text: string) => ReactNode
  renderNoMatches: (fullText: string) => ReactNode
}

function RegExpMatch({
  regexp,
  text,
  renderMatched,
  renderNoMatches,
  renderUnmatched,
  renderResult,
}: Props) {
  const result = []
  let index = 0
  let match
  let matchedText
  let matchPosition = -1

  do {
    match = regexp.exec(text)

    if (match != null) {
      const currentMatch: RegExpExecArray = match

      if (currentMatch.index > index) {
        result.push(renderUnmatched(index.toString(), text.substring(index, currentMatch.index)))
      }

      matchedText = currentMatch[0]
      matchPosition++
      result.push(renderMatched(currentMatch.index.toString(), matchedText, matchPosition))
      index = currentMatch.index + matchedText.length
    }
  } while (match != null)

  if (index === 0) {
    return <>{renderNoMatches(text)}</>
  }

  if (index < text.length - 1) {
    result.push(renderUnmatched(index.toString(), text.substring(index)))
  }

  return <>{renderResult(result)}</>
}

export default memo<Props>(RegExpMatch)
